// extracted by mini-css-extract-plugin
export default {"container":"Logout_container__idrod","title":"Logout_title__5KfFK","text":"Logout_text__PN4id","buttonContainer":"Logout_buttonContainer__Cewy+","button":"Logout_button__GFbu8"};